export default __webpack_public_path__ + "static/media/rabbit_type_4_3.eb5880e8.svg";